import React, { FC } from 'react';

import { BUTTON_TYPES } from '@evinced-private/ui-common';

import { IconTextButton } from 'src/common/components/icon-text-button/IconTextButton';
import { SelectionStatusBar } from 'src/common/components/selection-status-bar/SelectionStatusBar';
import AddLabelIcon from 'src/resources/icons/AddLabel.svg?raw';
import ChangeValueIcon from 'src/resources/icons/ChangeValue.svg?raw';
import RemoveLabelsIcon from 'src/resources/icons/RemoveLabels.svg?raw';

import './TableSelectionActions.scss';

interface ITableSelectionActionsProps {
	selectedCount: number;
	onClearSelection: () => void;
	processingMessage?: string | null;
	promptText: string;
	itemName: string;
	cancelButtonLabel?: string;
	addLabelButtonLabel: string;
	changeLabelValueButtonLabel: string;
	removeLabelsButtonLabel: string;
	onAddLabel: () => void;
	onChangeLabelValue: () => void;
	onRemoveLabels: () => void;
	disabled?: boolean;
}

export const TableSelectionActions: FC<ITableSelectionActionsProps> = ({
	selectedCount,
	onClearSelection,
	processingMessage,
	promptText,
	itemName,
	cancelButtonLabel,
	addLabelButtonLabel,
	changeLabelValueButtonLabel,
	removeLabelsButtonLabel,
	onAddLabel,
	onChangeLabelValue,
	onRemoveLabels,
	disabled = false
}) => {
	const isButtonsDisabled = selectedCount === 0 || disabled || !!processingMessage;

	return (
		<div className="table-selection-actions">
			<SelectionStatusBar
				selectedCount={selectedCount}
				onCancel={onClearSelection}
				processingMessage={processingMessage}
				promptText={promptText}
				itemName={itemName}
				cancelButtonLabel={cancelButtonLabel}
			/>
			<div className="table-selection-actions__buttons">
				<IconTextButton
					icon={AddLabelIcon}
					label={addLabelButtonLabel}
					type={BUTTON_TYPES.PRIMARY}
					disabled={isButtonsDisabled}
					onClick={onAddLabel}
					accessibilityProps={{ 'aria-haspopup': 'dialog' }}
				/>
				<IconTextButton
					icon={ChangeValueIcon}
					label={changeLabelValueButtonLabel}
					type={BUTTON_TYPES.PRIMARY}
					disabled={isButtonsDisabled}
					onClick={onChangeLabelValue}
					accessibilityProps={{ 'aria-haspopup': 'dialog' }}
				/>
				<IconTextButton
					icon={RemoveLabelsIcon}
					label={removeLabelsButtonLabel}
					type={BUTTON_TYPES.PRIMARY}
					disabled={isButtonsDisabled}
					onClick={onRemoveLabels}
					accessibilityProps={{ 'aria-haspopup': 'dialog' }}
				/>
			</div>
		</div>
	);
};
